import { render, staticRenderFns } from "./IntestazioneField.vue?vue&type=template&id=3dabf1c9&"
import script from "./IntestazioneField.vue?vue&type=script&lang=js&"
export * from "./IntestazioneField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports